export default __webpack_public_path__ + "static/media/34.97b9dcb9.jpeg";